import { render, staticRenderFns } from "./GlobalSpinner.vue?vue&type=template&id=1076c1dc"
import script from "./GlobalSpinner.vue?vue&type=script&lang=js"
export * from "./GlobalSpinner.vue?vue&type=script&lang=js"
import style0 from "./GlobalSpinner.vue?vue&type=style&index=0&id=1076c1dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports